<template>
  <v-app>
    <v-card width="400px" class="mt-5 mx-auto">
    </v-card>
  </v-app>
</template>
<script>
import shared from "@/services/shared";
import VueCookie from "vue-cookie";

export default {
  name: 'SSO',
  data () {
    return {
    }
  },
  methods: {
    doLogin() {
      let clientID = "ceikeeghahva2Pho"; //kurse.stuck-komzet.de
      clientID = "aec7che2AhR9Iwouwehu";
      let state = shared.randomString(18);
      let url = process.env.VUE_APP_ADMIN_URL+"/sso/login?client_id="+clientID+"&redirect_uri="+process.env.VUE_APP_HOME_URL+"/anmeldung-sso/&scope=openid%20email&response_type=code&state="+state;
      VueCookie.set('ssoStateToken', state);
      VueCookie.set('targetLoginRoute', this.$route.query.targetRoute);
      VueCookie.set('referrer', document.referrer);
      console.log( "refferer: " +  document.referrer);
      document.location.href = url;
    }
  },
  created() {
    this.doLogin();
  },
  beforeRouteUpdate(to, from, next) {
    this.doLogin();
    next();
  }
}
</script>

<style scoped>

</style>
